"use client";

import Chevron from "@/components/icons/Chevron";
import useSortModal from "@/lib/hooks/plpUseSortModal";
import type { DepictSort } from "@/lib/hooks/useProductFilter/types";
import { useQueryParams } from "@frend-digital/ui/next";
import * as Popover from "@radix-ui/react-popover";
import clsx from "clsx";
import { Suspense, startTransition } from "react";
import styles from "./SortPopover.module.css";

export interface SortPopoverProps {
  sortOrder: DepictSort[];
}

const UnsuspendedSortPopover = ({ sortOrder }: SortPopoverProps) => {
  const { isOpen, toggleModal } = useSortModal();
  const searchParams = useQueryParams({
    shallow: false,
    replace: true,
  });
  const currentSortOrder = searchParams.getAll("sort");

  const onChange = (value: DepictSort) => {
    startTransition(() => {
      searchParams.set("sort", `${value.field}_${value.order}`);
    });
  };

  return (
    <Popover.Root open={isOpen} onOpenChange={toggleModal}>
      <Popover.Trigger className={styles.trigger}>
        <Chevron className={clsx(styles.chevron, isOpen && styles.open)} />
        <button type="button">SORT BY</button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content className={styles.content}>
          {sortOrder?.map((option, i) => {
            const isActive =
              searchParams.get("sort")?.replace(`_${option.order}`, "") ===
              option.field;

            return (
              <button
                type="button"
                key={i}
                disabled={
                  isActive || (i === 0 && currentSortOrder.length === 0)
                }
                onClick={() => onChange(option)}
                className={styles.filter}
              >
                {option.meta.title}
              </button>
            );
          })}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export const SortPopover: typeof UnsuspendedSortPopover = props => {
  return (
    <Suspense
      fallback={
        <button type="button" className={styles.trigger}>
          SORT BY
        </button>
      }
    >
      <UnsuspendedSortPopover {...props} />
    </Suspense>
  );
};
